export var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map